import { StatsigClient } from '@statsig/react-bindings';
import config from '../../../common/config';
import { AbstractBehavioralTool, AnalyticsTools, Preferences } from '../../../components/consent-modal/types';
import { LOADED_A_PAGE, STATSIG_EVENTS } from '../constants';

export class StatsigTool extends AbstractBehavioralTool {
	private static clientInstance: StatsigClient | null = null;
	private isAnonymized = true;
	private isLoaded = false;

	private static readonly WHITELISTED_EVENTS: Set<string> = new Set([
		...Object.values(STATSIG_EVENTS)
	]);

	constructor() {
		super();
		if (!StatsigTool.clientInstance) {
			StatsigTool.clientInstance = new StatsigClient(
				config.statsig.sdkKey,
				{},
				{
					loggingEnabled: 'disabled',
					disableStorage: false,
					environment: { tier: config.statsig.tier }
				}
			);
			StatsigTool.clientInstance.initializeAsync().catch(() => undefined);
		}
	}

	public getClient(): StatsigClient {
		if (!StatsigTool.clientInstance) {
throw new Error('Statsig client not initialized');
}
		return StatsigTool.clientInstance;
	}

	public async load(userPreferences: Preferences) {
		this.isAnonymized = userPreferences.analytics !== true;
		if (StatsigTool.clientInstance) {
			StatsigTool.clientInstance.updateRuntimeOptions({
				loggingEnabled: this.isAnonymized ? 'disabled' : 'browser-only',
				disableStorage: false
			});
		}
		this.isLoaded = true;
	}

	private isEventWhitelisted(event: string): boolean {
		return StatsigTool.WHITELISTED_EVENTS.has(event);
	}

	public track(event: string, properties: Record<string, unknown>): void {
		if (!StatsigTool.clientInstance || !this.isLoaded || this.isAnonymized) {
return;
}
		if (!this.isEventWhitelisted(event)) {
			console.warn(`Statsig: Event "${event}" is not whitelisted and will not be tracked`);
			return;
		}
		const statsigProperties: Record<string, string> = {};
		for (const [key, value] of Object.entries(properties)) {
			statsigProperties[key] = String(value);
		}
		StatsigTool.clientInstance.logEvent(event, null, statsigProperties);
	}

	private getPathWithoutRestaurantSlug(pathname: string) {
		const segments = pathname.split('/').filter(Boolean);
		return '/' + segments.slice(1).join('/');
	}

	public page(path: string, properties: Record<string, unknown>): void {
		if (!StatsigTool.clientInstance || !this.isLoaded || this.isAnonymized) {
return;
}
		const pathWithoutSlug = this.getPathWithoutRestaurantSlug(path);
		const statsigProperties: Record<string, string> = {};
		for (const [key, value] of Object.entries(properties)) {
			statsigProperties[key] = String(value);
		}
		statsigProperties.path = pathWithoutSlug;
		StatsigTool.clientInstance.logEvent(LOADED_A_PAGE, pathWithoutSlug, statsigProperties);
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	public identify(userId: string, traits: Record<string, unknown>): void {
 return;
}

	public get supportsMiddleware(): boolean {
 return false;
}
	public get key(): AnalyticsTools {
 return AnalyticsTools.STATSIG;
}
}
